import { Initialize } from "../../state/actions/Search";

export default function goToLinkInternally(url, e) {
  if (e && e.button === 0 && !e.ctrlKey && !e.metaKey) {
    e.preventDefault();
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    History.pushState({}, document.title, url);
    Initialize();
  }
}
